<template>
  <div class="reports">
    <ReportWinloseComponent
      :ref-key-text="refKeyText"
      :title="title"
      :url-path="urlPath"
      :route-name="routeName"
      :is-simple="true"
    />
  </div>
</template>

<script>
import ReportWinloseComponent from '@/components/ReportWinloseComponent.vue'

export default {
  components: {
    ReportWinloseComponent,
  },
  data() {
    return {
      refKeyText: 'Username',
      title: 'W/L Member (Simple)',
      urlPath: '/reports/member_winlose_simple',
      routeName: 'reports-member-winlose-simple',
    }
  },
}
</script>

<style>

</style>
